import React, { useState, useEffect, useContext } from "react";

import axios from "axios";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button.js";
import AutocompleteTagsInput from "components/Input/AutocompleteTagsInput.js";
import TextInput from "components/Input/TextInput.js";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import Chip from "@mui/material/Chip";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { region } from "variables/patrimoine.js";
import { makeStyles } from "@mui/styles";
import { getSite, getFiles } from "services/ConfigServices";
import { NotificationManager } from 'react-notifications';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  tabs: {
    borderRight: `1px solid rgba(0, 0, 0, 0.12)`,
  },
  tab: {
    paddingLeft: "0rem",
    marginLeft: "0rem",
    flexDirection: "column",
    textAlign: "left",
    display: "grid",
    justifyContent: "left",
    alignItems: "flex-start",
    maxWidth: "3rem",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
  select: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0.5rem",
  },
  switch: {
    marginLeft: "0.5rem",
  },
}));

function Renewables(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const [pvpotential, setPvpotential] = useState("");
  const [solarthermalpotential, setSolarthermalpotential] = useState("");
  const [biomasspotential, setBiomasspotential] = useState("");
  const [geothermalpotential, setGeothermalpotential] = useState("");
  const [windpowerpotential, setWindpowerpotential] = useState("");
  const [associatedfiles, setAssociatedfiles] = useState("");
  const [comments, setComments] = useState("");
  const [description, setDescription] = useState("");

  const [gedList, setGedList] = useState([{ name: String, id: Number }]);

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const handlePvpotentialChange = (event) => { setPvpotential(event.target.value); };
  const handleSolarthermalpotentialChange = (event) => { setSolarthermalpotential(event.target.value); };
  const handleBiomasspotentialChange = (event) => { setBiomasspotential(event.target.value); };
  const handleGeothermalpotentialChange = (event) => { setGeothermalpotential(event.target.value); };
  const handleWindpowerpotentialChange = (event) => { setWindpowerpotential(event.target.value); };
  const handleAssociatedfilesChange = (newValue) => { setAssociatedfiles(newValue); };
  const handleCommentsChange = (event) => { setComments(event.target.value); };
  const handleDescriptionChange = (event) => { setDescription(event.target.value); };

  const selectedGed = () => {
    let gedCardId = [];
    let getGedNames;
    if (associatedfiles !== undefined) {
      for (let i = 0; i < associatedfiles.length; i++) {
        gedCardId.push(associatedfiles[i].fileId);
      }
      getGedNames = gedList.filter((gedList) =>
        gedCardId.includes(gedList.fileId)
      );
    }
    return getGedNames;
  };

  useEffect(() => {
    axios
      .get(
        getFiles(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        getSite(chartIdGroup, "renewables"),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        setPvpotential(res.data.detail.renewables?.pvpotential);
        setSolarthermalpotential(res.data.detail.renewables?.solarthermalpotential);
        setBiomasspotential(res.data.detail.renewables?.biomasspotential);
        setGeothermalpotential(res.data.detail.renewables?.geothermalpotential);
        setWindpowerpotential(res.data.detail.renewables?.windpowerpotential);
        setAssociatedfiles(res.data.detail.renewables?.associatedfiles || []);
        setComments(res.data.detail.renewables?.comments);
        setDescription(res.data.detail.renewables?.description);
      })
      .catch(() => { });
  }, []);

  const handleEdit = () => {
    axios
      .put(
        getSite(chartIdGroup, "renewables"),
        {
          pvpotential,
          solarthermalpotential,
          biomasspotential,
          geothermalpotential,
          windpowerpotential,
          associatedfiles,
          comments,
          description,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Modifications enregistrées");
        }
        else {
          NotificationManager.error("Une erreur est survenue");
        }
      })
      .catch(() => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const classes = useStyles();
  const autocompleteOptions = [];
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div>
            <TextInput
              inputTitle={region.renewables.pvpotential}
              textInput={pvpotential}
              handleTextInputChange={handlePvpotentialChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={region.renewables.solarthermalpotential}
              textInput={solarthermalpotential}
              handleTextInputChange={handleSolarthermalpotentialChange}
              disabled={!realestateupdate}
            />
          </div>

          <div>
            <TextInput
              inputTitle={region.renewables.biomasspotential}
              textInput={biomasspotential}
              handleTextInputChange={handleBiomasspotentialChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={region.renewables.geothermalpotential}
              textInput={geothermalpotential}
              handleTextInputChange={handleGeothermalpotentialChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <TextInput
              inputTitle={region.renewables.windpowerpotential}
              textInput={windpowerpotential}
              handleTextInputChange={handleWindpowerpotentialChange}
              disabled={!realestateupdate}
            />
          </div>
          <div>
            <AutocompleteInput
              disabled={!realestateupdate}
              inputTitle={region.renewables.associatedfiles}
              selected={selectedGed()}
              list={gedList}
              handleChange={(_, newValue) =>
                handleAssociatedfilesChange(newValue)
              }
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => (
                  <Chip label={option.title} {...getTagProps({ index })} />
                ))
              }
            />
          </div>
          <div>
            <TextInput
              inputTitle={region.renewables.comments}
              textInput={comments}
              handleTextInputChange={handleCommentsChange}
              disabled={!realestateupdate}
            />
          </div>

          <div>
            <TextInput
              inputTitle={region.renewables.description}
              textInput={description}
              handleTextInputChange={handleDescriptionChange}
              disabled={!realestateupdate}
            />
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              marginTop: "1rem",
              marginLeft: "auto",
              marginRight: "0.2rem",
            }}
          >
            {realestateupdate ? <Button
              style={{
                color: "#FFFFFF",
                backgroundColor: "#91C73C",
                fontWeight: "normal",
                fontWeight: "bold",
                height: "40px",
                fontSize: "0.75rem",
                padding: "5px 15px",
                marginRight: "5px",
                marginBottom: "0px",
                marginTop: "0px",
                fontFamily: '"Source Sans Pro",sans-serif',
              }}
              onClick={() => {
                handleEdit();
              }}
            >
              Enregistrer
            </Button> : <></>}
          </div>
        </GridItem>
      </GridContainer>

    </div>
  );
}

export { Renewables };
